import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { API_BASE_URL } from './config/api'

import "bootstrap"
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faUserSecret, faUmbrella, faWrench, faTrailer, faBell, faBellSlash } from '@fortawesome/free-solid-svg-icons';

window.__fcfazBuildMarker = 'accesorii-ui-2026-09-21-1';

library.add(faUserSecret, faUmbrella, faWrench, faTrailer, faBell, faBellSlash)

axios.defaults.baseURL = API_BASE_URL
axios.defaults.withCredentials = true

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresLogin)) {
        if ((!store.state.authenticated)) {
            next();//next({name: 'login'})
        } else {
            next();
        }
    } else {
        next();
    }
})

// Inregistrare Service Worker (pentru PWA)
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js', { scope: '/' })
            .then((registration) => {
                console.log('Service Worker inregistrat cu succes:', registration);
            })
            .catch((error) => {
                console.error('Eroare la inregistrarea Service Worker:', error);
            });
    });
}

const application = createApp(App).use(store).use(router, axios);
application.component('font-awesome-icon', FontAwesomeIcon);

application.mount('#app');

